import Model from '../../ModelBinding/Model';
import OrderCollection from './OrderCollection';
import OrderLineItemCollection from '../OrderLineItem/OrderLineItemCollection';
import dayjs from 'dayjs';
import Member from '../Member/Member';

export default class Order extends Model {
  public current_status?: string;
  public organization_id?: string;
  public created_by?: Member;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public activable?: boolean;
  public order_items?: OrderLineItemCollection;

  bind() {
    this.current_status = this.getStringAttribute('current_status');
    this.organization_id = this.getStringAttribute('organization_id');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.activable = this.getBooleanAttribute('activable');
    this.order_items = this.getRelationCollection(
      'order_items',
      OrderLineItemCollection,
    ) as OrderLineItemCollection;
  }

  static getCollection() {
    return OrderCollection;
  }
}
